import AOS from 'aos';
//import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init({
  delay: 150,
  duration: 800
});


